module.exports = __webpack_public_path__ + "img/recharge-share-image.1e08fed.png";